import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import type { AutoInvoiceNavigationModal } from '../../commands/types';

type GenerateAutoInvoiceDialogProps = {
  payload: AutoInvoiceNavigationModal | null;
  currentPath: string;
  onNavigate: (url: string) => void;
  onClose: () => void;
};

export const GenerateAutoInvoiceDialog = ({
  payload,
  currentPath,
  onNavigate,
  onClose,
}: GenerateAutoInvoiceDialogProps) => {
  if (!payload) return null;

  const handleGoToInvoice = () => {
    // Build URL matching legacy pattern:
    // /finances/invoices/output/4191?returnUrl=<encoded current path>
    const returnUrl = encodeURIComponent(currentPath);
    const baseUrl = payload.redirectUrl.endsWith('/')
      ? payload.redirectUrl
      : `${payload.redirectUrl}/`;
    const invoiceUrl = `${baseUrl}${payload.invoiceId}?returnUrl=${returnUrl}`;
    onNavigate(invoiceUrl);
    onClose();
  };

  return (
    <Dialog open={Boolean(payload)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Generate Invoice</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: 'pre-line' }}>
          {payload.message}
          {'\n\nDo you want to go to the invoice page?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Stay here
        </Button>
        <Button onClick={handleGoToInvoice} variant="contained" autoFocus>
          Go to Invoice
        </Button>
      </DialogActions>
    </Dialog>
  );
};
